// Тема оформления: 'light' | 'dark'.
// Хранится в localStorage (storage.theme), применяется атрибутом data-theme на <html>.
// Инлайн-скрипт в public/index.html выставляет тот же атрибут до загрузки CSS,
// чтобы страница не мигала светлым при открытии в тёмной теме — ключ и логика
// должны совпадать с ним.
import { storage } from '@/helpers/base/localstorage'

export const THEMES = ['light', 'dark']
export const THEME_STORAGE_KEY = 'theme'
export const THEME_CHANGE_EVENT = 'themechange'

export function getSystemTheme() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light'
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}

export function getSavedTheme() {
  const saved = storage.get(THEME_STORAGE_KEY)
  return THEMES.includes(saved) ? saved : null
}

export function getTheme() {
  const current = document.documentElement.getAttribute('data-theme')
  if (THEMES.includes(current)) return current
  return getSavedTheme() || getSystemTheme()
}

export function isDarkTheme() {
  return getTheme() === 'dark'
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme)
  // Bootstrap 5.3 перекрашивает свои компоненты по этому атрибуту
  document.documentElement.setAttribute('data-bs-theme', theme)
  window.dispatchEvent(
    new CustomEvent(THEME_CHANGE_EVENT, { detail: { theme } })
  )
}

export function setTheme(theme) {
  if (!THEMES.includes(theme)) return
  storage.set(THEME_STORAGE_KEY, theme)
  applyTheme(theme)
}

export function toggleTheme() {
  const next = isDarkTheme() ? 'light' : 'dark'
  setTheme(next)
  return next
}

// Подписка на смену темы. Возвращает функцию отписки
export function onThemeChange(callback) {
  const handler = event => callback(event.detail.theme)
  window.addEventListener(THEME_CHANGE_EVENT, handler)
  return () => window.removeEventListener(THEME_CHANGE_EVENT, handler)
}

// Значение CSS-переменной текущей темы — для Chart.js и прочего canvas,
// куда переменные напрямую не передать
export function cssVar(name, fallback = '') {
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    name
  )
  return value ? value.trim() : fallback
}

// Вызывается один раз при старте. Если пользователь тему не выбирал —
// следуем системной и реагируем на её смену
export function initTheme() {
  applyTheme(getSavedTheme() || getSystemTheme())
  if (!window.matchMedia) return
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      if (!getSavedTheme()) applyTheme(getSystemTheme())
    })
}
